import { notificationCenterUrl } from "./constants";
export default {
    appLoading: () => "application-loading",
    mainContent: () => "main-content",
    contentTab: (url) => {
        if (url.includes(notificationCenterUrl)) {
            return "notification-center";
        }
        else {
            return "";
        }
    },
};
